export default function ChartIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.08333 2.66667C4.08333 2.29848 3.78486 2 3.41667 2C3.04848 2 2.75 2.29848 2.75 2.66667V13.3333C2.75 13.7015 3.04848 14 3.41667 14H14.0833C14.4515 14 14.75 13.7015 14.75 13.3333C14.75 12.9651 14.4515 12.6667 14.0833 12.6667H4.08333V2.66667ZM15.2833 5.4C15.5042 5.10545 15.4446 4.68758 15.15 4.46667C14.8554 4.24575 14.4376 4.30545 14.2167 4.6L11.6779 7.98506L8.55474 4.86193C8.31093 4.61812 7.92143 4.60045 7.65654 4.82119L5.65654 6.48785C5.37369 6.72356 5.33548 7.14394 5.57119 7.42679C5.8069 7.70964 6.22727 7.74786 6.51012 7.51215L8.04242 6.23523L11.2786 9.4714C11.4153 9.60806 11.6045 9.67869 11.7973 9.66499C11.99 9.65129 12.1674 9.55461 12.2833 9.4L15.2833 5.4Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
